var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNxpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 870.19 470",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6d9a45;\n      }\n\n      .cls-2 {\n        fill: #938647;\n      }\n\n      .cls-3 {\n        fill: #bfd730;\n      }\n\n      .cls-4 {\n        fill: #fcb316;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #6dacde;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M516.17,81.55h-16.5l-60.86,101.94-60.86-101.94h-16.5V388.36h16.58l60.86-101.94,60.77,101.94h16.66l-.16-.25V81.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.46,81.55h-90.18l90.1,153.41-90.1,153.41h90.18V81.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.51,81.55h-90.26V388.12l.16,.25h90.1l-90.1-153.41,90.1-153.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M735.08,81.55h-128.57l-90.1,153.41,90.1,153.41h0v-67.8h152.26c63.88,0,83.07-52.44,83.07-98.1v-36.02c-.08-60.04-20.83-104.88-106.76-104.88h0Zm22.55,123.75c0,18.22-8.17,39.13-29.33,39.13h-121.71v-86.75h113.95c27.28,0,37,11.84,37,32.59l.08,15.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.37,234.96l-90.1-153.41h0v185.43L118.6,81.55H28.34V388.36H118.6V203.02l152.67,185.43,90.1-153.49Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 870.19,
    height: 470
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxpLogo);
export default __webpack_public_path__ + "static/media/nxp_logo.68f3bb243dbac4aea78aec76ed7fc578.svg";
export { ForwardRef as ReactComponent };